export default "__VITE_ASSET__6e453c73__"